/**
 * Fetch class for interacting with the WD API
 * Sets up a base request url and authorization token for WDFetch to use
 * @class WDApi
 */

import WDFetch from './wd-fetch'
import WDUtil from '../wd-util'

/**
 * WDApi extends WDFetch to provide API-specific configuration and methods.
 */
export default class WDApi extends WDFetch
{

  /**
   * Constructs a new WDApi instance.
   * @param {Object|string} baseCfg - Configuration object or URI string for the API request.
   * @param {Object} values - Optional values to pass to the parent constructor.
   */
  constructor(baseCfg, values)
  {
    let authHeader = null;
    // Start with a base config using the global API URL.
    const cfg = { reqURL: WDConfig.api.url };

    // If baseCfg is a string, treat it as a URI.
    if (typeof (baseCfg) == 'string')
    {
      cfg.reqURI = baseCfg;
    }
    // If baseCfg is an object, merge its properties into cfg.
    else if (typeof (baseCfg) == 'object')
    {
      WDUtil.merge(cfg, baseCfg);
    }

    // If authentication is enabled, add the Authorization header.
    if (WDConfig.auth.mode != 'none')
    {
      cfg.headers = { 'Authorization': WDAuth.authorization };
    }

    // Call the parent constructor with the final config and values.
    super(cfg, values);
  };

  /**
   * Initiates a download by requesting a nonce token, building a URL,
   * and opening it in a new window/tab.
   */
  download()
  {
    // Create a new WDApi instance for the /requesttoken endpoint.
    const p = new WDApi('/requesttoken');
    // Post to the endpoint and handle the response.
    p.post().then(data =>
    {
      // Build the download URL and append the nonce token.
      let url = this.buildURL().href;
      url += url.includes('?') ? '&' : '?';
      url += 'nonce_token=' + data.nonce_token;

      // If there are parameters, encode them as a JSON string.
      const params = this.toObject();
      if (Object.keys(params).length > 0)
      {
        url += '&parameters=' + JSON.stringify(params);
      }

      // Open the URL in a new window/tab.
      const win = window.open(url, '_blank');
      if (!win) alert('It appears you have a popup blocker installed.  Please disable it and try again');
    });

  };

  /**
   * Cleanup method to abort pending requests and clear resources
   */
  destroy() {
    // Call parent destroy to clean up WDFetch resources
    if (super.destroy) {
      super.destroy();
    }
    
    return this;
  }

};